import React from 'react';
import { createRoot } from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider, MsalContext } from '@azure/msal-react';
import { msalConfig } from './authConfig';
import AuthGuard from './AuthGuard';
import App from './App';
import { isDevAuthBypass, createDevMsalContextValue, DEV_USER_NAME } from './devAuth';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

const devAuthBypass = isDevAuthBypass();
const clientId = (process.env.REACT_APP_ENTRA_CLIENT_ID || '').trim();
let msalInstance = null;
let msalConfigError = '';

if (devAuthBypass) {
  // eslint-disable-next-line no-console
  console.info(`[BPMN-Editor] Lokaler Dev-Modus: Auth deaktiviert, Nutzer "${DEV_USER_NAME}".`);
} else if (!clientId) {
  msalConfigError = 'REACT_APP_ENTRA_CLIENT_ID ist nicht gesetzt.';
} else {
  try {
    msalInstance = new PublicClientApplication(msalConfig);
  } catch (err) {
    msalConfigError = err instanceof Error ? err.message : 'MSAL konnte nicht initialisiert werden.';
  }
}

const container = document.getElementById('root');
const root = createRoot(container);

function renderApp() {
  if (devAuthBypass) {
    root.render(
      <React.StrictMode>
        <MsalContext.Provider value={createDevMsalContextValue()}>
          <App />
        </MsalContext.Provider>
      </React.StrictMode>
    );
    return;
  }

  root.render(
    <React.StrictMode>
      {msalInstance ? (
        <MsalProvider instance={msalInstance}>
          <AuthGuard>
            <App />
          </AuthGuard>
        </MsalProvider>
      ) : (
        <div style={{ display: 'flex', minHeight: '100vh', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}>
          <div style={{ maxWidth: 720 }}>
            <h2>BPMN Editor: Authentifizierung nicht konfiguriert</h2>
            <p>
              Die Anwendung wurde ohne gueltige Entra-Konfiguration gebaut und kann daher keine Sitzung erstellen.
            </p>
            <p>
              Detail: {msalConfigError || 'MSAL Provider fehlt.'}
            </p>
          </div>
        </div>
      )}
    </React.StrictMode>
  );
}

async function bootstrap() {
  if (devAuthBypass || !msalInstance) {
    renderApp();
    return;
  }

  try {
    const redirectResult = await msalInstance.handleRedirectPromise();
    if (redirectResult?.account && msalInstance.setActiveAccount) {
      msalInstance.setActiveAccount(redirectResult.account);
    } else if (!msalInstance.getActiveAccount?.()) {
      const allAccounts = msalInstance.getAllAccounts?.() || [];
      if (allAccounts.length > 0 && msalInstance.setActiveAccount) {
        msalInstance.setActiveAccount(allAccounts[0]);
      }
    }
  } catch (err) {
    // Keep app usable and let AuthGuard trigger a fresh login if needed.
    // eslint-disable-next-line no-console
    console.warn('MSAL redirect handling failed:', err);
  }

  renderApp();
}

bootstrap();